import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";
// import Stack from "react-bootstrap/Stack";
// import { Icon } from "components/Icons";
import { colors } from "utils/styles";
import renderItem from "utils/renderItem";

import ImageCard from "@components/Reusables/ImageCard";
import LeftRight from "@components/Reusables/LeftRight";
import Title from "@components/Reusables/Title";
import MetaTitle from "@components/Reusables/MetaTitle";
import ButtonGroup from "@components/Reusables/ButtonGroup";
// import RichTextColumn from "@components/Reusables/RichTextColumn";
// import RenderComponents from "@components/Reusables/RenderComponents";

export default function MultiColumnTextAndImage(props) {
	const fields = props.data?.fields;

	const topPadding = fields?.topPadding || 3;
	const bottomPadding = fields?.bottomPadding || 3;

	const reverse = fields?.imageLeft;
	const leftSideOffset = fields?.leftSideOffset;
	const leftSideClasses = fields?.leftSideClasses || "";
	const rightSideClasses = fields?.rightSideClasses || "";

	const reverseAndOffset = reverse && leftSideOffset;
	const onlyReverse = reverse && !leftSideOffset;
	const onlyOffset = !reverse && leftSideOffset;
	const notReverseNoOffset = !reverse && !leftSideOffset;

	const mdCol = 8;
	const smCol = 9;
	const xsCol = 10;

	const SectionTitle = (
		<Row>
			{fields?.metaTitle && (
				<Col xs={12}>
					<MetaTitle metaTitle={fields?.metaTitle} />
				</Col>
			)}
			{fields?.title && (
				<Col xs={12}>
					<Title title={fields?.title} />
				</Col>
			)}
		</Row>
	);

	const TextColumn = (props) => {
		const textColumn = props.textColumn;
		const classes = props.classes || " ";

		return (
			<Col xs={12} className={`px-2 ${classes} flex-column d-flex  `} sm={6}>
				{textColumn.map((component) => {
					const key = component?.sys?.id;

					return <React.Fragment key={key}>{renderItem(component)}</React.Fragment>;
				})}
			</Col>
		);
	};

	return (
		<>
			<LeftRight
				leftCol={fields?.leftColumnWidth}
				rightCol={fields?.rightColumnWidth}
				reverse={reverse}
				outerBgColor={colors[fields?.backgroundColor?.fields?.color]}
				contentBgColor={colors[fields?.contentBackgroundColor?.fields?.color]}
				topPadding={topPadding}
				bottomPadding={bottomPadding}
				isWideContainer={fields?.isWideContainer}
				leftBgColor={fields?.leftBackgroundColor}
				rightBgColor={fields?.rightBackgroundColor}
				topSide={
					<>
						{/* Title section only shown on small */}
						<Row className="d-flex g-0  text-center d-lg-none justify-content-center">
							<Col xs={xsCol} sm={smCol} md={mdCol}>
								{SectionTitle}
							</Col>
						</Row>
					</>
				}
				leftSide={
					<div className={`leftSide-multi-text-image ${leftSideClasses} w-100`}>
						<Row className=" justify-content-start g-0 flex-row">
							{/* Logic to handle offset left or right, TODO refactor to reflect left/right vs reverse */}
							<Col
								xs={{ offset: reverse ? 0 : leftSideOffset ? 0 : 0, span: 12 }}
								lg={{
									offset: reverseAndOffset ? 1 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
									span: reverseAndOffset ? 10 : onlyOffset ? 10 : onlyReverse ? 11 : 12,
								}}
								xl={{
									offset: reverseAndOffset ? 1 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
									span: reverseAndOffset ? 10 : onlyOffset ? 10 : onlyReverse ? 11 : 12,
								}}
								xxl={{
									offset: reverseAndOffset ? 2 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
									span: reverseAndOffset ? 9 : onlyOffset ? 10 : onlyReverse ? 11 : 12,
								}}
							>
								{/* Title section only shown on larger screen */}
								<Row className="d-none d-lg-block  justify-content-center ">
									<Col xs={12} className="">
										{SectionTitle}
									</Col>
								</Row>
								{/* Main Content Container*/}
								<Row className="justify-content-center g-0">
									<Col className="mt-3 " xs={11} sm={11} md={10} lg={12}>
										<Row className=" g-0 justify-content-center ">
											{fields?.column1 && <TextColumn textColumn={fields?.column1} classes="" />}
											{fields?.column2 && <TextColumn textColumn={fields?.column2} />}
										</Row>
										{fields?.buttons && (
											<Row>
												<Col className="pt-lg-4">
													<ButtonGroup buttonGroupData={fields?.buttons} />
												</Col>
											</Row>
										)}

										{fields?.components && (
											<Row className="justify-content-center g-0">
												{fields?.components.map((component) => {
													const model = component?.sys?.contentType?.sys.id;
													const key = component?.sys?.id;
													const colWidth = component.fields?.columnWidth || 12;

													return (
														<Col
															xs={colWidth}
															key={key}
															className={` d-flex text-center  renderedItem`}
														>
															{renderItem(component)}
														</Col>
													);
												})}
											</Row>
										)}
									</Col>
								</Row>
							</Col>
						</Row>
					</div>
				}
				rightSide={
					<Row className="w-100 justify-content-center g-0">
						<Col className="" xs={11} sm={11} md={8} lg={12}>
							<ImageCard data={fields?.image} />
						</Col>
					</Row>
				}
			/>
		</>
	);
}
